import { RemoteApiProvider } from '@v2/services/flowsteps/remote-api-provider';
import { ProviderType } from 'shared/types/flowstep';
import { userStore } from 'src/stores';
import { ProviderClient, ProviderFactory } from 'shared/providers/provider';
import { SalesforceClientReportProvider } from 'shared/providers/salesforce/testing/salesforce-client-report-provider';

class FrontendProviderFactory extends ProviderFactory {
  getProviderClient(providerType: ProviderType): ProviderClient {
    if (providerType === ProviderType.SalesforceDebugReport) {
      return new SalesforceClientReportProvider();
    }

    if (!userStore.token) {
      throw new Error('No user token provided');
    }
    return new RemoteApiProvider(userStore.token, providerType);
  }
}

export default FrontendProviderFactory;
